<div class="flex align-items-center justify-content-between w-full h-full">
  <div class="grow">
    <ng-content/>
  </div>

  <div class="flex items-center ml-2.5 gap-2"
       [class.flex-col]="actionsLayout() === 'column'"
       [class.flex-row]="actionsLayout() === 'row'"
       [class.self-start]="actionsLayout() === 'row'"
  >
    <ng-content select="[leadingActions]"/>
    <span class="w-fit"
          tooltipPosition="left"
          [pTooltip]="`Clear Input for ${tooltipLabel()}`"
    >
      <button pButton
              type="button"
              class="clear-input-btn"
              data-test="clear-input-button"
              outlined="true"
              severity="secondary"
              iconOnly
              [disabled]="isEffectiveDisabled()"
              (click)="onClear()"
      >
        <i class="pi pi-times"></i>
      </button>
    </span>
    <ng-content select="[actions]"/>
  </div>
</div>
